import { Stack } from '@mantine/core'
import FacilityDetailsInfo from './facility-details-info'


export default function FacilityPage() {

    return (
        <Stack w="100%">
            <FacilityDetailsInfo />
        </Stack>
    )
}